import { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import Route from '../../../shared/routes/Route'
import Create from '../factories/Create'
import { ListFactory } from '../factories/List'
import VeiculoRoutes from '../utils/VeiculoRoutes'

const VeiculosRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <Route
        path={VeiculoRoutes.LIST}
        isPrivate
        exact
        component={ListFactory}
      />
      <Route path={VeiculoRoutes.CREATE} isPrivate exact component={Create} />
    </Switch>
  )
}

export default VeiculosRoutes
